import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { api, type Me } from './lib/api';
import { AppShell } from './components/AppShell';
import { LoginPage } from './pages/LoginPage';
import { LandingPage } from './pages/LandingPage';
import { ImpressumPage, DatenschutzPage } from './pages/LegalPages';
import { AgbPage } from './pages/AgbPage';
import { SitesPage } from './pages/SitesPage';
import { SiteDetailPage } from './pages/SiteDetailPage';
import { OrganizationsPage } from './pages/OrganizationsPage';
import { AccountPage } from './pages/AccountPage';
import { Spinner } from './components/ui';

export default function App() {
  const [me, setMe] = useState<Me | null>(null);
  const [checked, setChecked] = useState(false);

  const refresh = useCallback(async () => {
    try {
      setMe(await api.me());
    } catch {
      setMe(null);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  if (!checked) {
    return (
      <div className="grid min-h-dvh place-items-center text-[var(--text-muted)]">
        <Spinner />
      </div>
    );
  }

  return (
    <BrowserRouter>
      {me ? (
        <Routes>
          {/*
            Impressum und Datenschutz bleiben auch angemeldet erreichbar, und
            zwar unter derselben Adresse. Sonst zeigt ein geteilter Link je
            nach Anmeldestatus etwas anderes.
          */}
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/agb" element={<AgbPage />} />
          <Route
            path="*"
            element={
              <AppShell me={me}>
                <Routes>
                  <Route path="/sites" element={<SitesPage me={me} />} />
                  <Route path="/sites/:siteId" element={<SiteDetailPage />} />
                  <Route path="/organizations" element={<OrganizationsPage me={me} />} />
                  <Route path="/konto" element={<AccountPage me={me} />} />
                  <Route path="*" element={<Navigate to="/sites" replace />} />
                </Routes>
              </AppShell>
            }
          />
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/agb" element={<AgbPage />} />
          <Route path="/login" element={<LoginPage onAuthenticated={refresh} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </BrowserRouter>
  );
}
